// What colour an event is, on every calendar view (#130).
//
// An event's fill is its category's colour, and its attendance is a glyph
// (`StatusGlyph`): one legend across every view. MMS's chips are a pale wash
// of the category's colour with a saturated left edge, with attendance in a
// glyph (`research/mms-capture/SPEC.md` §2.3), and the colour is the one a
// teacher chose in the Edit Category drawer's swatch picker.
//
// Nothing is struck through. MMS has no cancelled occurrence: deleting "This
// event" removes it, and Teacher Cancelled is an attendance status drawn on
// the unchanged fill. Here a removed entry is a rule date in the series'
// `exceptions` and is not drawn (#152, #154), and a called-off lesson is an
// attendance status that only the glyph shows (#158). MMS draws one red
// circled ✕ for `Absent, Notice Given` and both Teacher Cancelled statuses
// alike; ours knowingly differs (StatusGlyph.jsx).
//
// The Android agenda paints the same way (`categoryPaint` in
// `ui/theme/CategoryPaint.kt`, #147).
//
// An event with no category gets no colour: `colorFor` returns null for an id
// that names no category, and this returns the plain class. An event with a
// bare `categoryLabel` (#110) belongs to no category, and painting it
// Lesson-blue would assert the match `relabelCategory` refuses to make.

// The class and the inline colour, together, because they are one decision.
//
// `--category-color` is a hex the studio picked out of the swatch list, so it
// cannot be a token and arrives inline; each stylesheet does every mix against
// it, as `--invoice-accent` does for the colour picked in Business Settings.
//
// `classes` is the caller's own module: `plain` and `tinted`.
export function categoryPaint(source, colorFor, classes = {}) {
  const colour = source?.categoryId ? colorFor?.(source.categoryId) || null : null;
  if (!colour) return { className: classes.plain };
  return {
    className: classes.tinted,
    style: { '--category-color': colour },
  };
}
